module.exports = __webpack_public_path__ + "static/assets/8fce012eae86a324f5917ff7b5e979be.png";